// extracted by mini-css-extract-plugin
module.exports = {"title":"Overview_title_3cano","title_":"Overview_title__1296x","subTitle":"Overview_subTitle_35RYt"};